export default __webpack_public_path__ + "static/media/familia-ntorq.832e5abd.svg";